import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

import { GetQuestionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import {
  LanguageType,
  QuestionResponseTypeEnum,
} from '../../../common/pokCore/validation/enums';

import { PublicTextQuestion } from './PublicTextQuestion';
import { PublicYesNoQuestion } from './PublicYesNoQuestion';
import { PublicYesNoTextQuestion } from './PublicYesNoTextQuestion';
import { AnswerValues } from './PublicSurveyContainer';

interface PublicSurveyQuestionProps {
  question: GetQuestionDto;
  value: AnswerValues;
  language: string;
  onChange: (value: AnswerValues) => void;
  error?: string;
  direction: 'left' | 'right';
}

export const PublicSurveyQuestion: React.FC<PublicSurveyQuestionProps> = ({
  question,
  value,
  language,
  onChange,
  error,
  direction,
}) => {
  const animationClass =
    direction === 'right'
      ? 'public-survey-animate-slide-in-right'
      : 'public-survey-animate-slide-in-left';
  const questionText =
    language === LanguageType.PL ? question.question : question.questionEn;

  return (
    <div className={`w-100 ${animationClass}`} key={question.id}>
      <div className="mb-4">
        <p
          className="public-survey-question-title"
          dangerouslySetInnerHTML={{
            __html: questionText,
          }}
        />
      </div>

      <div className="mb-4">
        {question.responseType === QuestionResponseTypeEnum.Text && (
          <PublicTextQuestion
            value={value.textValue}
            onChange={onChange}
            currentLanguage={language}
          />
        )}
        {question.responseType === QuestionResponseTypeEnum.YesNo && (
          <PublicYesNoQuestion
            value={value.booleanValue}
            onChange={onChange}
            currentLanguage={language}
          />
        )}
        {question.responseType === QuestionResponseTypeEnum.YesNoText && (
          <PublicYesNoTextQuestion
            value={value}
            onChange={onChange}
            currentLanguage={language}
          />
        )}
      </div>

      {error && (
        <div className="public-survey-alert public-survey-alert-error public-survey-animate-fade-in">
          <FaExclamationTriangle size={16} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};
